import {
  Icon,
  InternalLinkButton,
  TextEllipsis,
} from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import {
  formattedContactDetailsDate,
  getContactDetailsCompanyLink,
} from '../../../../utils';
import * as Styled from './styles';
import * as SX from './sx';
import type { CertificationItemProps as Props } from './types';

export const CertificationItem = memo(({ className, item, index }: Props) => {
  const companyLink = getContactDetailsCompanyLink(item.company);

  const handleClick = () => {
    if (item.url) {
      window.open(item.url, '_blank');
    }
  };

  return (
    <Card
      className={classnames('CertificationItem', className)}
      sx={SX.root}
      key={index}
      variant="filled"
      color="default"
    >
      <CardContent padding="extra">
        <Stack direction="row" gap={1}>
          <InternalLinkButton to={companyLink} fullWidth={false}>
            <Styled.Image src={item.company?.logo ?? ''}>
              <Icon sxx={SX.icon} size={21} name="apartment-rounded" />
            </Styled.Image>
          </InternalLinkButton>

          <Stack sx={{ width: '100%' }} gap={0.25}>
            <Typography variant="h6">{item.name}</Typography>

            <Box display="flex" justifyContent="space-between">
              <Box>
                <TextEllipsis
                  w={item.url ? '180px' : '256px'}
                  variant="body4"
                  color="black"
                >
                  {item.company?.name}
                </TextEllipsis>
                {item.date?.start && (
                  <Typography variant="body4" color="grey.500">
                    {`Issued ${formattedContactDetailsDate(item.date?.start)}`}
                  </Typography>
                )}
              </Box>

              {item.url && (
                <Box display="flex" alignItems="flex-end">
                  <Button
                    variant="outlined"
                    color="primary"
                    size="xsmall"
                    onClick={handleClick}
                    endIcon={<Icon name="open-in-new" size={12} />}
                  >
                    Show Credential
                  </Button>
                </Box>
              )}
            </Box>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
});

CertificationItem.displayName = 'CertificationItem';
